<template>
  <v-row v-if="displayModus === 'default'" class="mx-0 pt-4 pb-2 ">
    <v-col :cols="$vuetify.breakpoint.xs && !displayImg ? 8 : 12" class="pa-0">
      <div v-if="displayImg"
           style="background-color: #cfd1d3; width: 60px; height: 60px; float: left"
           :class="'pa-0 d-flex align-center justify-center ' + $vuetify.breakpoint.xs && displayImg ? 'mb-8 mr-3 ' : 'mb-3 mr-3 '">
        <v-img :src="require('@/assets/archetypes/individual.svg')" height="90%" contain/>
      </div>
      <v-btn v-if="$vuetify.breakpoint.smAndUp"
             @click="goTo({name: routeToStart, params: {origin: 'finStrategy'}})"
             color="transparent"
             class="ml-4 mb-6"
             style="float: right"
             :disabled="buttonDisabled"
             outlined>
        <fin-subscription-lock v-if="!checkIfRouteIsAllowed()" color="fin-color-primary-dark"/>
        Starten
      </v-btn>
      <span class="toolName">{{ name }}</span>
      <p class="toolDescription mb-0">{{ description }}</p>
      <v-btn v-if="$vuetify.breakpoint.xs && displayImg" :disabled="buttonDisabled"
             @click="goTo({name: routeToStart, params: {origin: 'finStrategy'}})"
             class="ml-1 mb-3 mt-2"
             light
             outlined>
       <fin-subscription-lock v-if="!checkIfRouteIsAllowed()" color="fin-color-primary-dark"/>
        Starten
      </v-btn>
    </v-col>
    <v-col cols="4" v-if="$vuetify.breakpoint.xs && !displayImg" class="pa-0 d-flex justify-center">
      <v-btn @click="goTo({name: routeToStart, params: {origin: 'finStrategy'}})"
             light
             outlined
             class="ml-1"
             :disabled="buttonDisabled">
        <fin-subscription-lock v-if="!checkIfRouteIsAllowed()" color="fin-color-primary-dark"/>
        Starten
      </v-btn>
    </v-col>
  </v-row>

  <v-row v-else-if="displayModus === 'iconModus'"
         class="mx-0"
         :style="($vuetify.breakpoint.xs ? 'padding: 16px 14px 16px 22px;' : 'padding: 33px 14px 32px 47px;') + ' background-color: #f7f7f7; margin-bottom: 32px'">
    <v-col class="pa-0" cols="2" sm="1">
      <v-icon class="mr-4 mb-12" :color="$finColors.primaryDark">
        icon-notification-info
      </v-icon>
    </v-col>
    <v-col class="pa-0" cols="10" sm="11">
      <p class="toolDescription">{{ description }}</p>
      <v-btn :disabled="buttonDisabled" :to="{name: routeToStart, params: {origin: 'finStrategy'}}" color="transparent"
             outlined>{{ name }}
      </v-btn>
    </v-col>
  </v-row>

</template>

<script>
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'fin-tool-row-display',
  components: {FinSubscriptionLock},
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    displayImg: {
      type: Boolean,
      default: true
    },
    routeToStart: {
      type: String
    },
    buttonAlign: {
      type: String,
      default: 'center'
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    checkIfRouteIsAllowed: {
      type: Function,
      default: () => {
        return true
      }
    },
    routeNotAllowedAction: {
      type: Function,
      default: () => {
        return true
      }
    },
    /* allowed values 'default' and 'iconModus'.
    - 'default' displays the image, then name and description, then button with label 'Starten'
    - 'iconModus' displays the information icon, then description, then button with the name als label
    */
    displayModus: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    goTo(route) {
      if (this.checkIfRouteIsAllowed()) {
        this.$router.push(route)
      } else {
        this.routeNotAllowedAction()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.toolName {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  hyphens: none;
}

.toolDescription {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  hyphens: none;
}
</style>
